import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Icon from "~/core/scripts/components/Icon";
import { numberFormat } from "~/core/scripts/utils";
import partyConfig from "../party-config";

function calculateSonstige(data) {
  return data.reduce(
    (res, item) => {
      res.valueRel -= item.valueRel;
      res.valueRelComp -= item.valueRelComp;
      return res;
    },
    {
      name: "sonstige",
      valueRel: 100,
      valueRelComp: 100,
      color: partyConfig.sonstige.max
    }
  );
}

function hexToRgb(hex) {
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function(m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (!result) {
    return null;
  }

  const r = parseInt(result[1], 16);
  const g = parseInt(result[2], 16);
  const b = parseInt(result[3], 16);

  return { r, g, b, rgbString: `${r},${g},${b}` };
}

function getLabelColor(item) {
  if (item.name === "Grüne") {
    return "#1F8F17";
  } else if (item.name === "FDP") {
    return "#D59300";
  }

  return item.color;
}

class PartyBars extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    isClickable: PropTypes.bool,
    showComparison: PropTypes.bool,
    scaleToMax: PropTypes.bool,
    decimalPlaces: PropTypes.number
  };

  static defaultProps = {
    onClick: () => {},
    isClickable: false,
    showComparison: true,
    scaleToMax: false,
    decimalPlaces: 0
  };

  getHeight(item, maxValue, key) {
    if (!this.props.scaleToMax) {
      return item[key] * 2;
    }

    return (100 / maxValue) * item[key];
  }

  render() {
    const {
      items,
      isClickable,
      selectedParty,
      showComparison,
      onClick,
      areaId = ""
    } = this.props;
    const bars = items.slice(0, 6);
    const sonstige = calculateSonstige(bars);
    const maxValueRel = Math.max(...bars.map(d => d.valueRel));
    const maxValueComp = showComparison
      ? Math.max(...bars.map(d => d.valueRelComp))
      : 0;
    const maxValue = Math.max(maxValueRel, maxValueComp);

    if (!items.length) {
      return null;
    }

    return (
      <div className="bars">
        {[...bars, sonstige].map(item => {
          const barHeight = this.getHeight(item, maxValue, "valueRel");
          const barHeightComp = this.getHeight(item, maxValue, "valueRelComp");

          const barClasses = classnames("bar__wrapper", {
            "is-clickable": isClickable && item.name !== "sonstige",
            "is-active": selectedParty === item.name
          });

          const showClose = isClickable && selectedParty === item.name;
          const itemRgb = hexToRgb(item.color);
          const labelColor = getLabelColor(item);

          return (
            <div
              key={`tooltip__bar-${item.name}`}
              className={barClasses}
              onClick={() => onClick(item.name)}
            >
              {showClose && (
                <div className="bar__close btn close">
                  <Icon type="close" />
                </div>
              )}

              <div className="bar__outer">
                <div
                  className="bar"
                  style={{
                    background: item.color,
                    height: `${barHeight}%`,
                    boxShadow: `0 3px 7px rgba(${itemRgb.rgbString}, 0.3)`
                  }}
                />
                {showComparison && (
                  <div
                    className="bar comparison"
                    style={{
                      background: item.color,
                      height: `${barHeightComp}%`,
                      boxShadow: `0 3px 7px rgba(${itemRgb.rgbString}, 0.3)`
                    }}
                  />
                )}
              </div>

              <div className="bar__party" style={{ color: labelColor }}>
                {partyConfig[item.name]
                  ? partyConfig[item.name].name
                  : item.name}
              </div>
              <div className="bar__value">
                {numberFormat(item.valueRel, 1)} %
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default PartyBars;
